type StringKeyedObject<T = unknown> = { [key: string]: T };

const removeUndefinedProperties = <T extends StringKeyedObject>(obj: T): Partial<T> =>
  Object.fromEntries(Object.entries(obj).filter(([, value]) => value !== undefined)) as Partial<T>;

export default removeUndefinedProperties;
